import { useEffect } from 'react';

import Toast from 'react-native-toast-notifications';

import { IServerOrder } from '@rbi-ctg/menu';
import { modalToaster } from 'components/toaster/refs';
import { toaster } from 'components/toaster/toaster';
import { t } from 'state/intl/translations';

let prevTotalCents: number | null = null;

export const OrderPriceChangeToast = ({ serverOrder }: { serverOrder: IServerOrder | null }) => {
  const toastMessage = t('restaurantPriceChangeToast');
  const currentCartTotal = serverOrder?.cart.totalCents ?? null;

  useEffect(() => {
    if (!currentCartTotal) {
      return;
    }

    // If there isn't a previous total, set it and do nothing else.
    // Only display the toast if the total changes.
    if (prevTotalCents === null) {
      prevTotalCents = currentCartTotal;
      return;
    }

    if (currentCartTotal !== prevTotalCents) {
      toaster.positive(toastMessage);
      prevTotalCents = null;
    }
  }, [currentCartTotal, toastMessage]);

  return (
    <Toast
      ref={x => {
        modalToaster.current = x;
      }}
    />
  );
};
